import { ApiPath } from "enums";
import { Get, Put } from "utils";

export const getPLBVIPRedemptions = async (query) => {
  const res = await Get(`${ApiPath.PLBVIPRedemptions}`, query);
  return res.data;
};

export const updateVIPRedemptionStatus = async ({ pointsHistoryId, status }) => {
  const res = await Put(`${ApiPath.UpdateVIPRedemptionStatus(pointsHistoryId)}`, { status });
  return res.data;
};
